/** Slugs unlocked in this page session — covers browsers that drop the cookie. */
const unlockedThisSession = new Set<string>()
const listeners = new Set<() => void>()

/** For `useSyncExternalStore` — notified whenever any gate sets or clears its cookie. */
export function subscribeLeadMagnetUnlock(notify: () => void) {
  listeners.add(notify)
  return () => listeners.delete(notify)
}

/** Client-side read of the `<slug>_unlocked` cookie (also read server-side by `requireLeadMagnetUnlock`). */
export function hasLeadMagnetUnlockCookie(slug: string): boolean {
  if (unlockedThisSession.has(slug)) return true
  if (typeof document === 'undefined') return false
  const prefix = `${slug}_unlocked=`
  return document.cookie.split(';').some((part) => part.trim().startsWith(prefix))
}

/** Persists the unlock across refresh so a return visit is not asked to submit again (duplicate Lead). */
export function setLeadMagnetUnlockCookie(slug: string): void {
  document.cookie = `${slug}_unlocked=1; path=/; SameSite=Lax`
  unlockedThisSession.add(slug)
  listeners.forEach((notify) => notify())
}

export function clearLeadMagnetUnlockCookie(slug: string): void {
  document.cookie = `${slug}_unlocked=; path=/; Max-Age=0; SameSite=Lax`
  unlockedThisSession.delete(slug)
  listeners.forEach((notify) => notify())
}
